import { put, race, take, call, select, delay } from 'redux-saga/effects'
import axios from '../../axios-local-api';
import * as actions from '../actions';
import * as actionTypes from '../actions/actionTypes';
import moment from 'moment';

const POLL_DELAY = 2500

const parseSteeringResults = (r) => {
  // "steering": {
  //   "forced": {
  //     "freqBand": "string",
  //     "expiresAt": "2022-03-17T16:54:43.766Z"
  //   }
  // },
  const { steering: s } = r.data;
  return s.forced;
}

const checkForTimeout = (initiated) => {
  if (new Date().getTime() - initiated >= 20000) {
    throw new Error('POLLING TIMED OUT')
  }
}

export function* startForcedSteeringSaga(action) {
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const { deviceMac, routerMac } = action
  if (sessionToken) {
    try {
      // 1. Initiate Band Steering
      const response = yield axios.put('/forceSteer', null, { params: { routerMac, deviceMac } });
      yield delay(2500)

      // 2. Start Polling
      yield call(resultsPollingWatcher, action);
      yield put(actions.initDevices({ action }));
      yield put(actions.initBandwidth());
      yield put(actions.initDeviceGroups());
      yield put(actions.enableAndDisableDeviceSteeringSuccess());


    } catch (startSpeedCheckError) {
      yield put(actions.enableAndDisableDeviceSteeringFailed('startSpeedCheckError'));
    }
  } else {
    console.error('NO TOKEN FOUND')
  }
}

export function* resultsPollingWatcher(action) {
  yield race({
    task: call(resultsPollingWorker, action),
    cancel: take(actionTypes.STOP_DEVICE_STEERING_POLLING)
  })
}

export function* resultsPollingWorker(action) {
  while (1) {
    try {
      // NEEDS MORE INFO TO HANDLE TIMEOUT
      // try {
      //   yield checkForTimeout(action.expiration)
      // } catch (timeOutError) {
      //   yield put(actions.enableAndDisableDeviceSteeringFailed(timeOutError))
      //   yield put({ type: actionTypes.STOP_DEVICE_STEERING_POLLING })
      // }

      const { deviceMac, routerMac } = action

      //* Fetch results
      try {
        const response = yield axios.get('/forceSteer', { params: { routerMac, deviceMac } })
        const parsedRes = yield parseSteeringResults(response);
        const { expiresAt: timestamp } = parsedRes;


        if (!!timestamp) {
          yield call(console.log, 'zx', timestamp)
          yield put(actions.setSteeringExpiresAt({ timestamp }))
          yield put({ type: actionTypes.STOP_DEVICE_STEERING_POLLING })
        } else {
          yield call(delay, POLL_DELAY)
        }
      } catch (errorWhilePolling) {
        yield put(actions.enableAndDisableDeviceSteeringFailed('errorWhilePolling'))
        yield put({ type: actionTypes.STOP_DEVICE_STEERING_POLLING })
      }
    } catch (fetchingLocalStateErrro) {
      yield put(actions.enableAndDisableDeviceSteeringFailed('fetchingLocalStateErrro'))
      yield put({ type: actionTypes.STOP_DEVICE_STEERING_POLLING })
    }
  }
}

export function* disableDeviceSteeringSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const deviceMac = action.deviceMac;
  if (sessionToken) {
    try {

      const axiosConfig = {
        method: 'delete',
        url: '/forceSteer/',
        params: {
          routerMac: rMac,
          deviceMac
        }
      }

      const response = yield axios(axiosConfig);
      // console.log(response, 'response')
      if (response.status === 200 || response.status === 204) {
        yield put(actions.initDevices({ action }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.enableAndDisableDeviceSteeringSuccess());
      } else {
        // console.log('FAILED DEVICES steering')
        yield put(actions.enableAndDisableDeviceSteeringFailed());
      }



    } catch (error) {
      // console.error('CHANGE DEVICES Steering  ERROR', error)
      yield put(actions.enableAndDisableDeviceSteeringFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.enableAndDisableDeviceSteeringFailed());

  }

}

export function* getDeviceSteeringSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');

  const deviceMac = action.deviceMac;
  if (sessionToken) {
    try {
      yield put(({ type: actionTypes.GET_DEVICE_STEERING_LOADING }))
      const axiosConfig = {
        method: 'get',
        url: '/forceSteer',
        params: {
          routerMac: rMac,
          deviceMac
        }
      }
      const response = yield axios(axiosConfig);
      // console.log(response, 'response')
      if (response.data.status === 200) {
        yield put(actions.initDevices({ action }));
        yield put(actions.initBandwidth());
        yield put(actions.initDeviceGroups());
        yield put(actions.getDeviceSteeringSuccess(response.data));
      } else {
        // console.log('FAILED DEVICES steering')
        yield put(actions.getDeviceSteeringFailed());
      }



    } catch (error) {
      // console.error('CHANGE DEVICES Steering  ERROR', error)
      yield put(actions.getDeviceSteeringFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.getDeviceSteeringFailed());

  }

}
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function* startSmartSteeringAllSaga(action) {
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  const routerMac = yield sessionStorage.getItem('mac');
  if (sessionToken) {
    try {
      yield put(({ type: actionTypes.START_DEVICE_STERING_ALL_POLLING_LOADING, isLoading: true }));
      // 1. Initiate Band Steering
      const response = yield axios.put('/forceSteer/all', null, { params: { routerMac } });
      const responseStatus = response?.data?.status || response?.status;
      if (responseStatus === 202 || responseStatus === 200) {
        yield put(actions.startSteeringAllSuccess());
        // yield sleep(3500);
        yield put(actions.refreshDevices({ selectedEquipment: action.selectedEquipment }));
        yield sleep(2000);
      } else {
        yield put(actions.startSteeringAllFailed());
      }
      yield put(({ type: actionTypes.START_DEVICE_STERING_ALL_POLLING_LOADING, isLoading: false }))

    } catch (error) {
      yield put(actions.startSteeringAllFailed());
      // console.log(error, "response 192")
      yield put(({ type: actionTypes.START_DEVICE_STERING_ALL_POLLING_LOADING, isLoading: false }))
    }
  } else {
    console.error('NO TOKEN FOUND')
  }
}